module.exports = __webpack_public_path__ + "static/media/suggestion-dictionary.5c939499.png";